import {
    Dmenu
} from './dmenu.js'; //ドロワーメニュー
import {
    Env
} from './env.js'; //ブラウザなど環境チェック
import {
    ScrChecker
} from './scroll-checker-simple.js';
import { Acc } from './accordion.js';//アコーディオン
import {
    Swp
} from './swp.js'; //Swiper
import { Opening } from './opening.js';//オープニング関連
import { ResizeElem } from './resize.js';// resize
import {
    Tab
} from './tab.js'; //タブ切り替え
import {
    PageAncher
} from './page-ancher.js'; //ページ内アンカーリンク（スムーズスクロール）
import {
    Urlparam
} from './urlparam.js'; // URLパラメータ

import smoothscroll from 'smoothscroll-polyfill';
// https://www.npmjs.com/package/smoothscroll-polyfill
// http://iamdustan.com/smoothscroll/

// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Main {
    constructor() {
        this.timerResized = false; //resize時
        this.timerScrolled = false; //scroll時
        this._click = '';
        this.env = {};
        this.loadedFlg = false;
        this.scrChecker = {};
        this.sliders = {};
        this.openingManager = {};
        this.tabs = {};
        this.resize = {};

        this.cursor;
        this.hoverCursorArrowElems;

        this.conceptCanvas;
    }

    showWorksContent() {
        let template;
        let clone;
        if (document.getElementById('works-content-template')) {
            template = document.getElementById('works-content-template');
            clone = template.content.cloneNode(true);
            document.getElementById('js-works-content-container').appendChild(clone);
        }
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];


        //ブラウザバック時
        window.addEventListener('pageshow', () => {
            this.body = document.getElementsByTagName('body')[0];
            this.menuCheckBox = document.getElementById('drawer-menu-trigger');
            this.body.classList.remove('drawer-menu-open');
            this.menuCheckBox.checked = false;
        });

        
        // DOMContentLoaded時
        // ------------------------------
        window.addEventListener('DOMContentLoaded', () => {

            //works cover画像
            // let img_elements = document.querySelectorAll('.heading-visual__img img');
            // let img_elements_count = img_elements.length;
            // let loaded_img = 0;
            // for(let i=0; i<img_elements_count; i++) {
            //     console.log(img_elements[i]);
            //     img_elements[i].addEventListener('load', (e)=> {
            //         loaded_img ++;
            //         console.log(loaded_img, img_elements_count);
            //         if(loaded_img>=img_elements_count){
            //             this.body.classList.add('show-works-title');
            //         }
            //     });
            // }


            // ブラウザOS環境
            this.env = new Env();
            this.env.detectEnv();
            this.env.detectRatio();

            // スクロールチェッカー
            this.scrChecker = new ScrChecker();
            this.scrChecker.init();

            //page ancher
            smoothscroll.polyfill();
            this.pageAncher = new PageAncher();
            this.pageAncher.init();

            // dmenu
            let dmenu = new Dmenu();
            dmenu.init();

            // アコーディオン
            this.accordions = new Acc();
            this.accordions.init();

            // Openingチェッカー
            this.openingManager = new Opening();
            this.openingManager.startLoader();

            //resize
            this.resize = new ResizeElem();
            this.resize.init();

            // スクロール時
            window.addEventListener('scroll', () => {
                this.scrChecker.onUpdate();
            });

            // ウインドウリサイズ時
            window.addEventListener('resize', () => {
                if (this.timerResized !== false) {
                    clearTimeout(this.timerResized);
                }
                this.timerResized = setTimeout(() => {
                    this.accordions.accResize();
                    if(this.body.classList.contains('loaded')){
                        this.env.detectRatio();//先に
                        this.resize.resizing();
                        this.tabs.onResize();
                        if(this.sliders.hasSwipers){
                            this.sliders.onResize();
                        }
                    }
                }, 400);
            });

            // cursor-image
            // ----------
            this.cursor = document.getElementById('cursor');
            window.addEventListener('pointermove', (e) => {
                this.cursor.style.top = `${e.clientY}px`;
                this.cursor.style.left = `${e.clientX}px`;
            });
            
            // #cover-opening-link-circle
            // if(document.getElementById('cover-opening-link-circle') && this.html.classList.contains('device-click')){
                
            //     let indexConcept = document.querySelector('.index-concept');
            //     let coCircle = document.getElementById('cover-opening-link-circle');

            //     coCircle.addEventListener('mouseover', (e) => {
            //         //console.log(e.currentTarget);
            //         this.cursor.classList.remove('cursor--default');
            //         if(indexConcept.classList.contains('concept-text-fadein-finished')){
            //             this.cursor.classList.add('cursor--branding');
            //         }else{
            //             this.cursor.classList.add('cursor--on-img');
            //         }
            //     });
            //     coCircle.addEventListener('mouseout', (e) => {
            //         //console.log(e.currentTarget);
            //         this.cursor.classList.remove('cursor--on-img');
            //         this.cursor.classList.remove('cursor--branding');
            //     });
            // }


            if(document.querySelectorAll('.block-common-vimeo')[0]){
                document.querySelectorAll('.block-common-vimeo').forEach((elem) => {
                    //cursor--default
                    elem.addEventListener('mouseover', (e) => {
                        //console.log(e.currentTarget);
                        this.cursor.classList.add('cursor--default');
                    });
                    elem.addEventListener('mouseout', (e) => {
                        //console.log(e.currentTarget);
                        this.cursor.classList.remove('cursor--default');
                    });
                });
            }
            


        });

        // load時
        // ------------------------------
        window.addEventListener("load", () => {
            this.loadedFlg = true;
            this.body.classList.add('loaded');
            this.openingManager.loaded();

            //works
            if (document.getElementById('works-content-template')) {
                this.showWorksContent();
                window.setTimeout(() => {
                    this.body.classList.add('show-works-title');
                }, 300);
            }

            //timeout時間
            let durationAfterLoad = 10;
            if (document.getElementById('cover-opening')) {
                durationAfterLoad = 6000;
            }

            window.setTimeout(() => {
                this.openingManager.showMainContent();

                // font： typesquare APIはスタンダードプランII以上でないと使えない
                //window.loadFont();

                // Swiper
                this.sliders = new Swp();
                this.sliders.init();

                //cursor large
                this.hoverCursorArrowElems = document.querySelectorAll('.js-cursor');
                [].forEach.call(this.hoverCursorArrowElems, (elem) => {
                    elem.addEventListener('mouseover', (e) => {
                        this.cursor.classList.add('cursor--on-img');
                    });
                    elem.addEventListener('mouseout', (e) => {
                        this.cursor.classList.remove('cursor--on-img');
                    });
                });

                //cursor gray
                this.hoverCursorGray = document.querySelectorAll('.js-cursor-gray');
                [].forEach.call(this.hoverCursorGray, (elem) => {
                    elem.addEventListener('mouseover', (e) => {
                        this.cursor.classList.add('cursor--on-gray');
                    });
                    elem.addEventListener('mouseout', (e) => {
                        this.cursor.classList.remove('cursor--on-gray');
                    });
                });

                // Tab
                this.tabs = new Tab();
                this.tabs.init();
                let initialtab = 0;
                
                let param = new Urlparam();
                let initialTabParam = param.returnParam('tab', location.href);
                //console.log(initialTabParam);

                if(initialTabParam == "corporate-branding"){
                    initialtab = 2;
                    param.removeParams();
                }
                if(initialTabParam == "business-branding"){
                    initialtab = 1;
                    param.removeParams();
                }
                if(initialtab>0){
                    this.tabs.onLoadTabChange(initialtab);
                }
                

                // Resize
                this.resize.resizing();

            }, durationAfterLoad);

        });
    }
}